// Fills in the gaps

// Based on errors reported by Airbrake
// Add any missing functionality (e.g. Array.from) via imports
// Github for mdn-polyfills: https://github.com/msn0/mdn-polyfills

// we need this, even though it isn't in our codebase
// because some transpiling plugin changes code to `Array.from`...
import "mdn-polyfills/Array.from"; // IE11
import "mdn-polyfills/Array.prototype.find"; // IE11
import "mdn-polyfills/Array.prototype.findIndex"; // IE11
import "mdn-polyfills/Array.prototype.includes"; // IE11
import "mdn-polyfills/CustomEvent"; // IE11 monkey patcher
import "mdn-polyfills/Element.prototype.closest"; // IE11
import "mdn-polyfills/Element.prototype.matches"; // IE11 copy existing method
import "mdn-polyfills/Element.prototype.toggleAttribute"; // IE11
import "mdn-polyfills/NodeList.prototype.forEach"; // IE11
import "mdn-polyfills/Object.assign"; // IE11
import "mdn-polyfills/Object.values"; // IE11
import "mdn-polyfills/String.prototype.endsWith"; // IE11

import "@ungap/url-search-params"; // IE11
import "details-element-polyfill"; // IE11
import 'promise-polyfill/src/polyfill'; // IE11
import "whatwg-fetch"; // IE11

import "../vendor/picturefill/picturefill.min"; // IE11
import "../vendor/picturefill/pf.mutation.min"; // IE11, also polyfills `matches` if missing



// WEBPACK FOOTER //
// ./core/polyfills.js